import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';

import { OdooSyncPage } from './imports';

export const odooSyncRoutes = [
  {
    path: 'odoo-sync',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.INTEGRATIONS}
            submodule={OrionSubmodule.INTEGRATIONS.ODOO_SYNC}
            access={OrionAccess.VIEW}
          >
            <OdooSyncPage />
          </PermissionGuard>
        ),
        index: true,
      },
    ],
  },
];
